import React from "react";
import { ManagePayrollCalendarContainer } from "../../containers";

const ManagePayrollCalendar = (props) => {
  return <ManagePayrollCalendarContainer {...props} />;
};

export default ManagePayrollCalendar;
